<template>
  <div>
    <!-- 기본현황 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 기본현황</h5>
      <div class="writeGridContainer">
        <div>
          <div>시설물번호</div>
          <ml-input v-model="form.facilityNumber" :readonly="readonly" />
        </div>
        <div>
          <div>관리번호</div>
          <ml-input v-model="form.managementNumber" :readonly="readonly" />
        </div>
        <div>
          <div>시설물명</div>
          <ml-input v-model="form.facilityName" :readonly="readonly" />
        </div>
        <div>
          <div>노선 - 구분</div>
          <ml-input v-model="form.routeDivision" :readonly="readonly" />
        </div>
        <div>
          <div>노선 - 세부노선</div>
          <ml-input v-model="form.routeDetail" :readonly="readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>시설물 구분</div>
          <vs-select autocomplete v-model="form.cat1" @change="onChangeCat1">
            <vs-select-item v-for="(option, idx) in cat1List" :key="idx" :text="option" :value="option" />
          </vs-select>
        </div>
        <div class="writeGridLineItem">
          <div>시설물 종류</div>
          <vs-select :disabled="!form.cat1" autocomplete v-model="form.cat2" @change="onChangeCat2">
            <vs-select-item v-for="(option, idx) in cat2List" :key="idx" :text="option" :value="option" />
          </vs-select>
        </div>
        <div class="writeGridLineItem">
          <div>시설물 세분류</div>
          <vs-select :disabled="!form.cat2" autocomplete v-model="form.cat3" @change="onChangeCat3">
            <vs-select-item v-for="(option, idx) in cat3List" :key="idx" :text="option" :value="option" />
          </vs-select>
        </div>
        <div>
          <div>종별</div>
          <vs-select :disabled="!form.cat3" autocomplete v-model="form.classification" @change="onChangeCat4">
            <vs-select-item v-for="(option, idx) in classificationList" :key="idx" :text="option" :value="option" />
          </vs-select>
        </div>
        <div>
          <div>SOC성능평가대상</div>
          <div class="radio">
            <vs-radio v-for="option in ['유', '무']" :key="`SOC성능평가대상_${option}`" v-model="form.socEvaluationTarget" vs-name="SOC성능평가대상" :vs-value="option" :disabled="readonly">{{ option }} </vs-radio>
          </div>
        </div>
        <div class="writeGridCol2">
          <div>주소</div>
          <ml-input v-model="form.address" placeholder="(시,도) (시,군,구) (읍,면,동) (리, 번지 등 주소)" :readonly="readonly" />
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>관리주체</div>
          <ml-input v-model="form.management_entity" :readonly="readonly" />
        </div>
        <div>
          <div>관리주체구분</div>
          <div class="radio">
            <vs-radio v-for="option in ['중앙부처', '지자체', '(국가/지방)공기업', '민간']" :key="`관리주체구분_${option}`" v-model="form.management_type" vs-name="관리주체구분" :vs-value="option" :disabled="readonly"
              >{{ option }}
            </vs-radio>
          </div>
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>소유자</div>
          <ml-input v-model="form.owner" :readonly="readonly" />
        </div>
        <div>
          <div>소유자구분</div>
          <div class="radio">
            <vs-radio v-for="option in ['중앙부처', '지자체', '(국가/지방)공기업', '민간']" :key="`소유자구분_${option}`" v-model="form.ownerType" vs-name="소유자구분" :vs-value="option" :disabled="readonly">{{ option }} </vs-radio>
          </div>
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>사업계획승인일</div>
          <DateSelector v-model="form.businessPlanApprovalDate" :readonly="readonly" />
        </div>
        <div>
          <div>준공(사용승인)일</div>
          <DateSelector v-model="form.completionDate" :readonly="readonly" />
        </div>
        <div>
          <div>하자담보책임만료일</div>
          <DateSelector v-model="form.defectLiabilityExpirationDate1" :readonly="readonly" />
        </div>
        <div>
          <div>상세제원</div>
          <div class="radio">
            <vs-radio v-for="option in ['유', '무']" :key="`상세제원_${option}`" v-model="form.detailedSpecifications" vs-name="상세제원" :vs-value="option" :disabled="readonly">{{ option }} </vs-radio>
          </div>
        </div>
        <div>
          <div>안전점검 및 정밀안전진단 이력</div>
          <div class="radio">
            <vs-radio v-for="option in ['유', '무']" :key="`안전점검및정밀안전진이력_${option}`" v-model="form.safetyInspectionAndDiagnosisHistory" vs-name="안전점검및정밀안전진이력" :vs-value="option" :disabled="readonly">
              {{ option }}
            </vs-radio>
          </div>
        </div>
        <div>
          <div>보수·보강 이력</div>
          <div class="radio">
            <vs-radio v-for="option in ['유', '무']" :key="`보수보강이력_${option}`" v-model="form.repairAndReinforcementHistory" vs-name="보수보강이력" :vs-value="option" :disabled="readonly">{{ option }} </vs-radio>
          </div>
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>환기구 덮개 (접근 가능한 환기구)</div>
          <div class="radio">
            <vs-radio v-for="option in ['유', '무']" :key="`환기구덮개_${option}`" v-model="form.accessibleVentCover" vs-name="환기구 덮개 (접근 가능한 환기구)" :vs-value="option" :disabled="readonly">{{ option }} </vs-radio>
          </div>
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>설계기간</div>
          <DateSelectorRang v-model="form.designPeriod" :readonly="readonly" />
        </div>
        <div>
          <div>설계자</div>
          <ml-input v-model="form.designer" :readonly="readonly" />
        </div>
        <div>
          <!--            <div>하자담보책임만료일</div>-->
          <!--            <DateSelector v-model="form.defectLiabilityExpirationDate2"  :readonly="readonly" />-->
        </div>
        <div>
          <div>공사기간</div>
          <DateSelectorRang v-model="form.constructionPeriod" :readonly="readonly" />
        </div>
        <div>
          <div>시공자</div>
          <ml-input v-model="form.contractor" :readonly="readonly" />
        </div>
        <div>
          <div>총공사비</div>
          <div class="after-text">
            <comma-input v-model="form.totalConstructionCost" :readonly="readonly" />
            <span>백만원</span>
          </div>
        </div>
        <div>
          <div>내진설계 대상 유무</div>
          <div class="radio">
            <vs-radio v-for="option in ['대상', '미대상', '불명']" :key="`내진설계대상유무_${option}`" v-model="form.seismicDesignTarget" vs-name="내진설계대상유무" :vs-value="option" :disabled="readonly">{{ option }} </vs-radio>
          </div>
        </div>
        <div>
          <div>내진설계 적용 유무</div>
          <div class="radio">
            <vs-radio v-for="option in ['적용', '미적용', '불명']" :key="`내진설계적용유무_${option}`" v-model="form.seismicDesignApplication" vs-name="내진설계적용유무" :vs-value="option" :disabled="readonly">{{ option }} </vs-radio>
          </div>
        </div>
        <div>
          <div>적용내진설계기준</div>
          <ml-input v-model="form.seismicDesignStandard" :readonly="readonly" />
        </div>
        <div>
          <div>내진성능평가 실시 유무</div>
          <div class="radio">
            <vs-radio v-for="option in ['실시', '미실시', '불명']" :key="`내진성능평가실시유무_${option}`" v-model="form.seismicPerformanceEvaluation" vs-name="내진성능평가실시유무" :vs-value="option" :disabled="readonly"
              >{{ option }}
            </vs-radio>
          </div>
        </div>
        <div>
          <div>내진보강 유무</div>
          <div class="radio">
            <vs-radio v-for="option in ['실시', '미실시', '불명']" :key="`내진보강유무_${option}`" v-model="form.seismicReinforcement" vs-name="내진보강유무" :vs-value="option" :disabled="readonly">{{ option }} </vs-radio>
          </div>
        </div>
      </div>
      <div class="writeGridContainer">
        <div>
          <div>영21조대상</div>
          <div class="radio">
            <vs-radio v-for="option in ['예', '아니오']" :key="`영21조대상_${option}`" v-model="form.young21Target" vs-name="영21조대상" :vs-value="option" :disabled="readonly">{{ option }} </vs-radio>
          </div>
        </div>
        <div>
          <div>감리기간</div>
          <DateSelectorRang v-model="form.auditPeriod" :readonly="readonly" />
        </div>
        <div>
          <div>감리자(책임감리원)</div>
          <ml-input v-model="form.auditor" :readonly="readonly" />
        </div>
        <div>
          <div>사업주체(발주자)</div>
          <ml-input v-model="form.projectOwner" :readonly="readonly" />
        </div>
        <div>
          <div>공사명</div>
          <ml-input v-model="form.constructionName" :readonly="readonly" />
        </div>
        <div>
          <div>공사감독·공사관리관</div>
          <ml-input v-model="form.constructionSupervisor" :readonly="readonly" />
        </div>
        <div>
          <div>작성일</div>
          <DateSelector v-model="form.creationDate" :readonly="readonly" />
        </div>
        <div>
          <div>작성자</div>
          <ml-input v-model="form.author" :readonly="readonly" />
        </div>
        <div>
          <div>서명</div>
          <sign-field v-model="form.signature" :readonly="readonly" />
        </div>
        <div>
          <div>최종 수정일</div>
          <DateSelector v-model="form.lastModifiedDate" :readonly="readonly" />
        </div>
        <div>
          <div>최종 수정자</div>
          <ml-input v-model="form.lastModifiedBy" :readonly="readonly" />
        </div>
        <div class="writeGridLineItem">
          <div>비고</div>
          <ml-textarea v-model="form.remarks" :readonly="readonly" />
        </div>
      </div>
    </div>

    <!-- 상세제원 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 상세제원</h5>

      <!-- - 사면위치 -->
      <h5 class="mb-3">- 사면위치</h5>
      <table class="mb-4">
        <colgroup>
          <col width="116" />
        </colgroup>
        <thead>
          <tr>
            <th></th>
            <th>시점</th>
            <th>종점</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>위도</td>
            <td>
              <ml-input v-model="form.사면위치.위도.시점" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <ml-input v-model="form.사면위치.위도.종점" :readonly="readonly" class="w-full" />
            </td>
          </tr>
          <tr>
            <td>경도</td>
            <td>
              <ml-input v-model="form.사면위치.경도.시점" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <ml-input v-model="form.사면위치.경도.종점" :readonly="readonly" class="w-full" />
            </td>
          </tr>
        </tbody>
      </table>
      <div class="writeGridContainer mt-3">
        <div>
          <div>주용도</div>
          <ml-input v-model="form.주용도" :readonly="readonly" />
        </div>
      </div>

      <!-- - 사면형상 -->
      <h5 class="mb-3">- 사면형상</h5>
      <table class="mb-4">
        <thead>
          <tr>
            <th>횡단지형</th>
            <th>횡단형상</th>
            <th>종단형상</th>
            <th>법면특징</th>
            <th>곡부개소수</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <ml-input v-model="form.사면형상.횡단지형" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <ml-input v-model="form.사면형상.횡단형상" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <ml-input v-model="form.사면형상.종단형상" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <ml-input v-model="form.사면형상.법면특징" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <ml-input v-model="form.사면형상.곡부개소수" :readonly="readonly" class="w-full" />
            </td>
          </tr>
        </tbody>
      </table>

      <!-- - 규모 -->
      <h5 class="mb-3">- 규모</h5>
      <table class="mb-4">
        <thead>
          <tr>
            <th>연장</th>
            <th>높이</th>
            <th>경사</th>
            <th>구성재료</th>
            <th>소단수</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <ml-input v-model="form.규모.연장" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <ml-input v-model="form.규모.높이" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <ml-input v-model="form.규모.경사" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <ml-input v-model="form.규모.구성재료" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <ml-input v-model="form.규모.소단수" :readonly="readonly" class="w-full" />
            </td>
          </tr>
        </tbody>
      </table>

      <!-- - 상부사면 -->
      <h5 class="mb-3">- 상부사면</h5>
      <table class="mb-4">
        <thead>
          <tr>
            <th>높이(깍기부포함)</th>
            <th>경사</th>
            <th>토층심도</th>
            <th>식생</th>
            <th>부석유무</th>
            <th>배수시설</th>
            <th>기타</th>
            <th>
              상부사면내 인공구조물<br />
              - 종류
            </th>
            <th>
              상부사면내 인공구조물 <br />
              - 위치
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <ml-input v-model="form.상부사면.높이" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <ml-input v-model="form.상부사면.경사" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <ml-input v-model="form.상부사면.토층심도" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <ml-input v-model="form.상부사면.식생" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <div class="flex justify-center items-center gap-2">
                <vs-radio v-for="option in ['유', '무']" :key="`상부사면부석유무${option}`" v-model="form.상부사면.부석유무" vs-name="상부사면부석유무" :vs-value="option" :disabled="readonly">{{ option }} </vs-radio>
              </div>
            </td>
            <td>
              <ml-input v-model="form.상부사면.배수시설" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <ml-input v-model="form.상부사면.기타" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <ml-input v-model="form.상부사면.인공구조물종류" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <ml-input v-model="form.상부사면.인공구조물위치" :readonly="readonly" class="w-full" />
            </td>
          </tr>
        </tbody>
      </table>

      <!-- - 하부사면 -->
      <h5 class="mb-3">- 하부사면</h5>
      <table class="mb-4">
        <thead>
          <tr>
            <th>높이(깍기부포함)</th>
            <th>경사</th>
            <th>형식/재료</th>
            <th>식생</th>
            <th>하천유무</th>
            <th>배수시설</th>
            <th>기타</th>
            <th>
              하부사면내 인공구조물<br />
              - 종류
            </th>
            <th>
              하부사면내 인공구조물 <br />
              - 위치
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <ml-input v-model="form.하부사면.높이" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <ml-input v-model="form.하부사면.경사" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <ml-input v-model="form.하부사면.형식재료" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <ml-input v-model="form.하부사면.식생" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <div class="flex justify-center items-center gap-2">
                <vs-radio v-for="option in ['유', '무']" :key="`하부사면하천유무${option}`" v-model="form.상부사면.하천유무" vs-name="하부사면하천유무" :vs-value="option" :disabled="readonly">{{ option }} </vs-radio>
              </div>
            </td>
            <td>
              <ml-input v-model="form.하부사면.배수시설" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <ml-input v-model="form.하부사면.기타" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <ml-input v-model="form.하부사면.인공구조물종류" :readonly="readonly" class="w-full" />
            </td>
            <td>
              <ml-input v-model="form.하부사면.인공구조물위치" :readonly="readonly" class="w-full" />
            </td>
          </tr>
        </tbody>
      </table>

      <!-- - 인접시설물 규모 -->
      <table-custom
        thema="label"
        :controls="true"
        :multiple="true"
        :board="{ readonly: readonly }"
        title="- 인접시설물 규모"
        titleType="noCircle"
        :tableData="[
          { id: 'count', title: '', type: 'no', width: 70 },
          { id: '종류', title: '종류', type: 'text', placeholder: '내용' },
          { id: '규모', title: '규모', type: 'text', placeholder: '내용' },
          { id: '특성', title: '특성', type: 'text', placeholder: '내용' },
          { id: '이격거리', title: '이격거리', type: 'text', placeholder: '내용' },
          { id: '기타', title: '기타', type: 'text', placeholder: '내용' },
        ]"
        :mobile="['target', 'name']"
        v-model="form.인접시설물규모"
        class="mb-3"
      />

      <!-- - 보강공법 -->
      <table-custom
        thema="label"
        :controls="true"
        :multiple="true"
        :board="{ readonly: readonly }"
        title="- 보강공법"
        titleType="noCircle"
        :tableData="[
          { id: 'count', title: '', type: 'no', width: 70 },
          { id: '공증', title: '공증', type: 'text', placeholder: '내용' },
          { id: '공법', title: '공법', type: 'text', placeholder: '내용' },
          { id: '적용구간', title: '적용구간', type: 'text', placeholder: '내용' },
          { id: '위치', title: '위치', type: 'text', placeholder: '내용' },
          { id: '비고', title: '비고', type: 'text', placeholder: '내용' },
        ]"
        :mobile="['target', 'name']"
        v-model="form.보강공법"
        class="mb-3"
      />

      <!-- 기타 상세제원 -->
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>기타 상세제원</div>
          <ml-textarea v-model="form.otherSpecifications" :readonly="readonly" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SignField from "@/components/SignField.vue";
import TableCustom from "@/components/TableCustom.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";
import DateSelector from "@/components/selector/DateSelector.vue";

export default {
  name: "RetainingWallWriteBody",
  components: {
    SignField,
    TableCustom,
    DateSelectorRang,
    DateSelector,
  },
  props: {
    readonly: Boolean,
    form: Object,
    label: String,
    initCat1List: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      cat1List: [],
      cat2List: [],
      cat3List: [],
      classificationList: [],
    };
  },
  async mounted() {
    // 만약 this.initCat1List 가 비어있다면, this.initCat1List를 초기화한다.
    if (this.initCat1List.length === 0) {
      let facilityCategoryListData = this.$store.state.project.fieldFacilityCategoryList;
      if (!facilityCategoryListData.data || facilityCategoryListData.data.length === 0) {
        facilityCategoryListData = await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_LIST", {});
      }
      const _cat1List = facilityCategoryListData.data.map((item) => item.cat1);
      const uniqueCat1List = [...new Set(_cat1List)];
      this.cat1List = this.sortItemAndMoveEtcItemToEnd(uniqueCat1List);
    } else {
      this.cat1List = this.initCat1List;
    }

    if (!this.cat1List.includes(this.form.cat1)) {
      this.form.cat1 = "";
      this.form.cat2 = "";
      this.form.cat3 = "";
      this.form.classification = "";
    } else {
      await this.onChangeCat1(this.form.cat1);
    }
  },
  methods: {
    // ==================================================
    // ==================== Category ====================
    // ==================================================
    async onChangeCat1(data) {
      if (data) {
        let facilityCategoryListData = this.$store.state.project.fieldFacilityCategoryList;
        if (!facilityCategoryListData.data || facilityCategoryListData.data.length === 0) {
          facilityCategoryListData = await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_LIST", {});
        }
        const _cat2List = facilityCategoryListData.data.filter((item) => item.cat1 === data).map((item) => item.cat2);
        const uniqueCat2List = [...new Set(_cat2List)];
        this.cat2List = this.sortItemAndMoveEtcItemToEnd(uniqueCat2List);

        // 만약 this.cat2가 this.cat2List 내에 없다면, cat2, cat3, cat4를 초기화한다.
        if (this.cat2List.indexOf(this.form.cat2) === -1) {
          this.form.cat2 = "";
          this.form.cat3 = "";
          this.form.classification = "";
        }
      }
    },
    async onChangeCat2(data) {
      if (data) {
        let facilityCategoryListData = this.$store.state.project.fieldFacilityCategoryList;
        if (!facilityCategoryListData.data || facilityCategoryListData.data.length === 0) {
          facilityCategoryListData = await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_LIST", {});
        }
        const _cat3List = facilityCategoryListData.data.filter((item) => item.cat1 === this.form.cat1 && item.cat2 === data).map((item) => item.cat3);
        const uniqueCat3List = [...new Set(_cat3List)];
        this.cat3List = this.sortItemAndMoveEtcItemToEnd(uniqueCat3List);

        // 만약 this.cat3가 this.cat3List 내에 없다면, cat3, cat4를 초기화한다.
        if (this.cat3List.indexOf(this.form.cat3) === -1) {
          this.form.cat3 = "";
          this.form.classification = "";
        }
      }
    },
    async onChangeCat3(data) {
      if (data) {
        let facilityCategoryListData = this.$store.state.project.fieldFacilityCategoryList;
        if (!facilityCategoryListData.data || facilityCategoryListData.data.length === 0) {
          facilityCategoryListData = await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_LIST", {});
        }
        const _classificationList = facilityCategoryListData.data.filter((item) => item.cat1 === this.form.cat1 && item.cat2 === this.form.cat2 && item.cat3 === data).map((item) => item.classification);
        const uniqueClassificationList = [...new Set(_classificationList)];
        this.classificationList = this.sortItemAndMoveEtcItemToEnd(uniqueClassificationList);

        // 만약 this.classification이 this.classificationList 내에 없다면, classification을 초기화한다.
        if (this.classificationList.indexOf(this.form.classification) === -1) {
          if (this.classificationList.length === 1) {
            this.form.classification = this.classificationList[0];
            await this.setFacilityCategoryId();
          } else {
            this.form.classification = "";
          }
        } else {
          await this.setFacilityCategoryId();
        }
      }
    },
    onChangeCat4(classification) {
      if (!this.catLock) {
        this.form.classification = classification;
        this.setFacilityCategoryId();
      }
    },

    /**
     * 현재까지 선택된 cat1, cat2, cat3, classification에 해당하는 facility_category_id를 설정하는 함수입니다.
     *
     * @returns {Promise<void>}
     */
    async setFacilityCategoryId() {
      let facilityCategoryListData = this.$store.state.project.fieldFacilityCategoryList;
      if (!facilityCategoryListData.data || facilityCategoryListData.data.length === 0) {
        facilityCategoryListData = await this.$store.dispatch("project/LOAD_FIELD_FACILITY_CATEGORY_LIST", {});
      }
      const found = facilityCategoryListData.data.filter((item) => item.cat1 === this.form.cat1 && item.cat2 === this.form.cat2 && item.cat3 === this.form.cat3 && item.classification === this.form.classification);

      if (found.length > 0) {
        this.form.facility_category_id = found[0].id;
      }
    },

    /**
     * 배열을 정렬하고, "기타" 문자가 포함된 항목을 배열의 마지막으로 이동하는 함수입니다.
     * 이 함수는 배열을 받아서, 배열의 요소를 정렬한 후, "기타" 문자가 포함된 항목을 찾아 배열의 마지막으로 이동시킵니다.
     *
     * @param {Array} list - 정렬하고, "기타" 문자가 포함된 항목을 마지막으로 이동시킬 배열
     * @returns {Array} 정렬되고, "기타" 문자가 포함된 항목이 마지막으로 이동된 배열
     */
    sortItemAndMoveEtcItemToEnd(list) {
      list.sort();

      // list 아이템 중에 "기타" 문자가 포함된 항목을 찾아서 배열의 마지막으로 이동시킨다.
      const otherIdx = list.findIndex((item) => item.includes("기타"));
      if (otherIdx !== -1) {
        list.push(list.splice(otherIdx, 1)[0]);
      }

      return list;
    },

    // ==================================================
    // ==================================================

    // 옹벽단수의 수만큼 옹벽분류,옹벽제원의 배열이 생성된다
    change옹벽단수() {
      const 옹벽단수 = this.form.옹벽단수;
      const 옹벽분류 = this.form.옹벽분류;
      const 옹벽제원 = this.form.옹벽제원;

      if (옹벽단수 > 옹벽분류.length) {
        for (let i = 옹벽분류.length; i < 옹벽단수; i++) {
          옹벽분류.push({
            단: i + 1,
            형식별: "",
            재료별: "",
            평면선형: "",
            평면선형: "",
            횡단선형: "",
          });
          옹벽제원.push({
            단: i + 1,
            옹벽전면부: {
              연장: "",
              높이: "",
              두께상단: "",
              두께하단: "",
            },
            옹벽저판부앞굽판: {
              가로: "",
              세로: "",
              두께앞: "",
              두께뒤: "",
            },
            옹벽저판부뒷굽판: {
              가로: "",
              세로: "",
              두께앞: "",
              두께뒤: "",
            },
            매립깊이: "",
            사면구배: "",
            인접보호시설물현황: {
              시설물명: "",
              규모: "",
            },
            이격거리: {
              내이격거리: "",
              외이격거리: "",
            },
            배수공: {
              지름크기: "",
              개수: "",
            },
            앵커유무: {
              유무: "",
              개수: "",
            },
            시공이음부유무: {
              유무: "",
              개수: "",
            },
          });
        }
      } else if (옹벽단수 < 옹벽분류.length) {
        옹벽분류.splice(옹벽단수, 옹벽분류.length - 옹벽단수);
        옹벽제원.splice(옹벽단수, 옹벽제원.length - 옹벽단수);
      }
    },
  },
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    font-size: 14px;
    font-weight: 500;
    text-align: center;

    border: 1px solid #cdcdcd;
    padding: 5px;
  }

  th {
    background: #f9f9f9;
    padding: 10px 4px;
  }
}
</style>
<style scoped lang="scss">
.table-list {
  .action-button {
    margin-left: auto;
  }
}

.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}

.title-n {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.size-search {
  width: 200px;
}

.input-se {
  width: 100%;

  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }

  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 10px !important;
  }

  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;

    &::before {
      content: "~";
      margin-right: 10px;
    }
  }

  &::v-deep .inline-block {
    width: 100% !important;
  }
}

.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}

.search-item {
  width: 100% !important;
  margin: 0 !important;

  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }

  &::v-deep > div:last-child {
    flex: 1 !important;

    .con-select {
      width: 100%;
    }
  }
}

.upload-img {
  width: 100%;
  height: 318px !important;
  margin-top: 22px;
}
</style>

<style lang="scss">
.none-card {
  box-shadow: none;
  border-radius: 0;
  display: inline-block;

  .vx-card__body {
    padding: 0 !important;
  }
}

span.up {
  color: #28c76f;
}

span.down {
  color: #ea5455;
}

.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}
</style>
